"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Table2 = _interopRequireDefault(require("@material-ui/core/Table"));

var _TableBody2 = _interopRequireDefault(require("@material-ui/core/TableBody"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _TableHead2 = _interopRequireDefault(require("@material-ui/core/TableHead"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _lodash = _interopRequireDefault(require("lodash.orderby"));

var _Checkbox = _interopRequireDefault(require("../../checkbox/Checkbox"));

var _TableSortLabel = _interopRequireDefault(require("./TableSortLabel"));

var _TableCell = _interopRequireDefault(require("./TableCell"));

var _TableRow = _interopRequireDefault(require("./TableRow"));

var _utils = require("../utils");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Table = /*#__PURE__*/(0, _react.forwardRef)(function Table(props, ref) {
  var columns = props.columns,
      data = props.data,
      defaultSortBy = props.defaultSortBy,
      defaultSortDirection = props.defaultSortDirection,
      dividers = props.dividers,
      onSelectionChange = props.onSelectionChange,
      onSort = props.onSort,
      rowKey = props.rowKey,
      selectable = props.selectable,
      zebra = props.zebra;

  var _useState = (0, _react.useState)({}),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      selected = _useState2[0],
      setSelected = _useState2[1];

  var _useState3 = (0, _react.useState)(defaultSortBy),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      sortBy = _useState4[0],
      setSortBy = _useState4[1];

  var _useState5 = (0, _react.useState)(defaultSortDirection),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      sortDirection = _useState6[0],
      setSortDirection = _useState6[1];

  var _useState7 = (0, _react.useState)(data),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      sortedData = _useState8[0],
      setSortedData = _useState8[1];

  var allSelected = data.every(function (item) {
    return selected[item[rowKey]];
  });
  var someChecked = !allSelected && data.some(function (item) {
    return selected[item[rowKey]];
  });
  (0, _react.useEffect)(function () {
    if (onSort) {
      onSort({
        data: data,
        sortBy: sortBy,
        sortDirection: sortDirection
      });
    } else {
      setSortedData((0, _lodash.default)(data, [sortBy], [sortDirection]));
    }
  }, [data, onSort, sortBy, sortDirection]);
  (0, _react.useEffect)(function () {
    onSelectionChange(selected);
  }, [onSelectionChange, selected]);
  return /*#__PURE__*/_react.default.createElement(_Table2.default, {
    className: "pds-table",
    ref: ref
  }, /*#__PURE__*/_react.default.createElement(_TableHead2.default, null, /*#__PURE__*/_react.default.createElement(_TableRow.default, null, selectable && /*#__PURE__*/_react.default.createElement(_TableCell.default, {
    padding: "checkbox"
  }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
    checked: allSelected,
    indeterminate: someChecked,
    id: "check-all",
    inputProps: {
      'aria-label': 'Toggle all'
    },
    onChange: function onChange(e) {
      var checked = e.target.checked;
      var newSelection = {};

      if (checked && !someChecked) {
        newSelection = data.reduce(function (acc, item) {
          acc[item[rowKey]] = true;
          return acc;
        }, {});
      }

      setSelected(newSelection);
    }
  })), columns.map(function (column) {
    var content = column.header;
    var handleSortClick;

    if (column.sortable) {
      handleSortClick = function handleSortClick() {
        var newSortDirection = 'asc';

        if (sortBy === column.field && sortDirection === 'asc') {
          newSortDirection = 'desc';
        }

        setSortDirection(newSortDirection);
        setSortBy(column.field);
      };

      content = /*#__PURE__*/_react.default.createElement(_TableSortLabel.default, {
        active: column.field === sortBy,
        direction: column.field === sortBy ? sortDirection : 'asc',
        onClick: handleSortClick
      }, content);
    }

    return /*#__PURE__*/_react.default.createElement(_TableCell.default, {
      key: column.id,
      align: column.align,
      className: column.className,
      sortable: column.sortable,
      sortDirection: column.field === sortBy ? sortDirection : false
    }, content);
  }))), /*#__PURE__*/_react.default.createElement(_TableBody2.default, null, sortedData.map(function (rowData) {
    var isRowSelected = !!selected[rowData[rowKey]];
    return /*#__PURE__*/_react.default.createElement(_TableRow.default, {
      key: rowData[rowKey],
      selected: isRowSelected,
      tabIndex: "0",
      zebra: zebra,
      hover: true
    }, selectable && /*#__PURE__*/_react.default.createElement(_TableCell.default, {
      dividers: dividers,
      padding: "checkbox"
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      checked: isRowSelected,
      id: "".concat(rowData[rowKey], "-cb"),
      inputProps: {
        'aria-label': 'Toggle'
      },
      onChange: function onChange(e) {
        var checked = e.target.checked;
        setSelected(function (previousSelection) {
          return _objectSpread(_objectSpread({}, previousSelection), {}, (0, _defineProperty2.default)({}, rowData[rowKey], checked));
        });
      }
    })), columns.map(function (column) {
      var content = (0, _utils.getCellContent)(column, rowData);
      return /*#__PURE__*/_react.default.createElement(_TableCell.default, {
        key: column.id,
        align: column.align,
        className: column.className,
        dividers: dividers,
        sorted: column.field === sortBy
      }, content);
    }));
  })));
});
Table.defaultProps = {
  defaultSortDirection: 'asc',
  dividers: true,
  onSelectionChange: function onSelectionChange() {},
  selectable: false,
  zebra: false
};
Table.propTypes = {
  /** Array of column definitions used to draw the table. */
  columns: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    align: (0, _propTypes.oneOf)(['center', 'left', 'right', 'justify']),
    className: _propTypes.string,
    field: _propTypes.string,
    header: _propTypes.node,
    id: _propTypes.string.isRequired,
    mobileProps: (0, _propTypes.shape)({
      visible: _propTypes.bool
    }),
    render: _propTypes.func,
    sortable: _propTypes.bool
  })).isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  data: _propTypes.array.isRequired,

  /** The field that should be used to sort the table initially. */
  defaultSortBy: _propTypes.string,

  /** The direction the table should be sorted initially. */
  defaultSortDirection: (0, _propTypes.oneOf)(['asc', 'desc']),

  /** If the table should have a border between each row. */
  dividers: _propTypes.bool,

  /** Callback that is called every time the selection changes in the table. */
  onSelectionChange: _propTypes.func,

  /** Function used to sort the table with a custom algorithm.  */
  onSort: _propTypes.func,

  /** The field that should be used to generate the React key of each row. */
  rowKey: _propTypes.string.isRequired,

  /** If the table should have checkboxes to select the rows. */
  selectable: _propTypes.bool,

  /** If the table should have zebra stripes. */
  zebra: _propTypes.bool
};
var _default = Table;
exports.default = _default;
